import { DryRunResult } from '../hooks/useDryRunWs';
import { ProductType } from '../hooks/useProducts';
import { OrderType } from '../types/orders';
import { formatNumberWithDecimals } from './formatters';
import { isMultipleOf } from './math';
import { getDryRunErrorMessage } from './orderError';

export const validateAmount = (amount: bigint, product: ProductType, close?: boolean) => {
  if (close) {
    if (amount !== 0n) {
      return `Amount must be zero for close order.`;
    }
    return;
  }

  if (amount < product.lotSize) {
    return `Below min amount ${formatNumberWithDecimals(product.lotSize)} ${product.baseTokenName}`;
  }

  if (amount > product.maxQuantity) {
    return `Above max amount ${formatNumberWithDecimals(product.maxQuantity)} ${product.baseTokenName}`;
  }

  if (!isMultipleOf(amount, product.lotSize)) {
    return `Amount must be a multiple of ${formatNumberWithDecimals(product.lotSize)}`;
  }
  return undefined;
};

export const getAmountError = ({
  amount,
  dryRunResult,
  product,
  enoughLiquidity,
  orderType,
}: {
  amount: bigint | undefined;
  dryRunResult: DryRunResult | null;
  product: ProductType;
  enoughLiquidity: boolean;
  orderType: OrderType;
}) => {
  const amountError = validateAmount(amount || 0n, product);
  if (amountError) {
    return amountError;
  }
  if (!enoughLiquidity && orderType === 'MARKET') {
    return 'Not enough liquidity in the orderbook';
  }
  if (dryRunResult) {
    return getDryRunErrorMessage(dryRunResult);
  }
  return undefined;
};
